import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { userPropTypes } from '../../../utils/propTypes';
import { FIELD } from '../constants/field';

const ProfileContext = createContext();

export const useProfileContext = () => useContext(ProfileContext);

export const ProfileContextProvider = ({
  children,
  userData,
  getUserInfo,
  submitError,
}) => {
  const value = useMemo(
    () => ({ userData, getUserInfo, submitError }),
    [userData, getUserInfo, submitError],
  );
  return (
    <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>
  );
};
ProfileContextProvider.propTypes = {
  userData: userPropTypes,
  getUserInfo: PropTypes.func.isRequired,
  submitError: PropTypes.shape({
    [FIELD.EMAIL]: PropTypes.string,
    [FIELD.MOBILE_PHONE]: PropTypes.string,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
